import { Modal } from 'react-bootstrap';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

interface NotificationModalStateProps {
  show: boolean;
  title: string;
  dismissLabel?: string;
}

interface NotificationModalDispatchProps {
  dismiss: () => void;
}

const ConfirmModalDialog: React.FC<
  NotificationModalStateProps & NotificationModalDispatchProps
> = ({ title, show, children, dismissLabel, dismiss }) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={dismiss} className='contact-us'>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer className='text-right'>
        <button className={'btn btn-sm btn-dark'} onClick={dismiss}>
          {dismissLabel || t('common_ok', { uppercase: true })}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModalDialog;
